import { setChannelInstanceId } from '../../search-and-filter-schema/protected';
export const updateChannelInstanceIdFilter = (filters, filterValue) => {
  return setChannelInstanceId(filterValue, filters);
};